import React from 'react';
import { stats } from '../data/content';
import useReveal from '../hooks/useReveal';
import './About.css';

export default function About() {
  const leftRef  = useReveal();
  const rightRef = useReveal();

  return (
    <section className="about" id="about">
      {/* Left */}
      <div className="about__text" ref={leftRef}>
        <span className="section-label">Who We Are</span>
        <h2 className="section-title">
          Spotless Spaces.<br />
          <em>Happier Places.</em>
        </h2>
        <p className="section-body">
          At Fresh Wave Solutions Limited, we provide reliable and professional
          cleaning services tailored to homes, businesses, and commercial spaces.
          We place our customers at the centre of everything we do, delivering
          dependable, detail-focused cleaning with integrity and excellence.
        </p>
        <p className="section-body">
          Our team is committed to the highest standards, offering competitive
          and negotiable rates designed to suit your specific needs.
        </p>

        <div className="about__stats">
          {stats.map((s) => (
            <div className="stat-card" key={s.label}>
              <div className="stat-card__num">{s.num}</div>
              <div className="stat-card__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Right */}
      <div className="about__visual" ref={rightRef}>
        <div className="about__photo-wrap">
          <img
            src="https://res.cloudinary.com/dsnontai6/image/upload/v1777321379/photo-1581578731548-c64695cc6952_k0xymh.jpg"
            alt="Clean, bright living space"
            className="about__photo"
          />
        </div>
        <div className="about__quote">
          <blockquote>
            "Let us keep your space spotless, fresh, and welcoming every single time."
          </blockquote>
          <cite>— Fresh Wave Solutions Limited</cite>
        </div>
        <div className="about__badge">
          <span className="about__badge-icon">🛡️</span>
          <div>
            <strong>Trusted &amp; Reliable</strong>
            <span>Excellence in every clean, guaranteed.</span>
          </div>
        </div>
      </div>
    </section>
  );
}
